import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";

const useStyles = makeStyles({
  root: {
    width: "100%",
    maxWidth: "100%",

    minHeight: "80vh",

    boxSizing: "border-box",

    background: "#353353",

    padding: "100px 7%",

    overflow: "hidden",
  },

  headingContainer: {
    maxWidth: 1200,

    margin: "0 auto 60px",
  },

  eyebrow: {
    display: "block",

    color: "#ff4f81",

    fontSize: 14,
    fontWeight: 700,

    textTransform: "uppercase",

    letterSpacing: 3,

    marginBottom: 8,
  },

  heading: {
    position: "relative",

    display: "inline-block",

    color: "#fff",

    fontSize: 45,
    fontWeight: 800,

    margin: 0,

    letterSpacing: -1,

    "&::after": {
      content: '""',

      position: "absolute",

      left: 0,
      bottom: -12,

      width: 55,
      height: 4,

      borderRadius: 10,

      background: "#ff0055",
    },
  },

  content: {
    width: "100%",
    maxWidth: 1200,

    margin: "0 auto",

    display: "grid",

    gridTemplateColumns: "0.9fr 1.1fr",

    gap: 30,

    alignItems: "stretch",
  },

  infoCard: {
    padding: 40,

    borderRadius: 20,

    background: "rgba(255, 255, 255, 0.045)",

    border: "1px solid rgba(255, 255, 255, 0.08)",

    boxSizing: "border-box",
  },

  title: {
    color: "#fff",

    fontSize: 28,

    fontWeight: 700,

    margin: "0 0 15px",
  },

  description: {
    color: "#aaa9bb",

    fontSize: 15,

    lineHeight: 1.8,

    margin: "0 0 30px",
  },

  contactItem: {
    display: "flex",

    alignItems: "center",

    gap: 15,

    marginBottom: 20,
  },

  iconBox: {
    width: 42,
    height: 42,

    flexShrink: 0,

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    borderRadius: 12,

    background: "rgba(255, 0, 85, 0.1)",

    color: "#ff4f81",
  },

  itemText: {
    margin: 0,

    color: "#aaa9bb",

    fontSize: 13,
  },

  itemValue: {
    display: "block",

    color: "#fff",

    fontSize: 14,

    fontWeight: 600,

    marginTop: 3,
  },

  emailLink: {
    color: "#fff",

    textDecoration: "none",

    transition: "color 0.3s ease",

    "&:hover": {
      color: "#ff4f81",
    },
  },

  ctaCard: {
    position: "relative",

    padding: "45px",

    borderRadius: 20,

    boxSizing: "border-box",

    overflow: "hidden",

    background:
      "linear-gradient(135deg, rgba(255, 0, 85, 0.14), rgba(108, 108, 229, 0.12))",

    border: "1px solid rgba(255, 255, 255, 0.08)",

    display: "flex",

    flexDirection: "column",

    justifyContent: "center",
  },

  circleOne: {
    position: "absolute",

    width: 220,
    height: 220,

    borderRadius: "50%",

    background: "rgba(255, 0, 85, 0.08)",

    top: -100,
    right: -70,
  },

  circleTwo: {
    position: "absolute",

    width: 150,
    height: 150,

    borderRadius: "50%",

    background: "rgba(108, 108, 229, 0.08)",

    bottom: -80,
    left: -50,
  },

  ctaContent: {
    position: "relative",

    zIndex: 1,
  },

  ctaLabel: {
    display: "inline-block",

    color: "#ff4f81",

    fontSize: 12,

    fontWeight: 700,

    textTransform: "uppercase",

    letterSpacing: 2,

    marginBottom: 12,
  },

  ctaTitle: {
    color: "#fff",

    fontSize: 34,

    lineHeight: 1.2,

    fontWeight: 800,

    margin: "0 0 18px",
  },

  ctaText: {
    maxWidth: 550,

    color: "#b4b3c2",

    fontSize: 15,

    lineHeight: 1.8,

    margin: "0 0 30px",
  },

  button: {
    display: "inline-flex",

    alignItems: "center",

    justifyContent: "center",

    gap: 8,

    width: "fit-content",

    padding: "13px 23px",

    borderRadius: 30,

    background: "#ff0055",

    color: "#fff",

    textDecoration: "none",

    fontSize: 14,

    fontWeight: 700,

    boxShadow: "0 10px 25px rgba(255, 0, 85, 0.2)",

    transition: "all 0.3s ease",

    "&:hover": {
      background: "#ff1767",

      color: "#fff",

      transform: "translateY(-3px)",

      boxShadow: "0 15px 30px rgba(255, 0, 85, 0.3)",
    },
  },

  footerText: {
    maxWidth: 1200,

    margin: "45px auto 0",

    color: "#77768c",

    fontSize: 12,

    textAlign: "center",
  },

  "@media (max-width: 900px)": {
    content: {
      gridTemplateColumns: "1fr",
    },
  },

  "@media (max-width: 650px)": {
    root: {
      padding: "70px 20px",
    },

    headingContainer: {
      marginBottom: 45,
    },

    heading: {
      fontSize: 36,
    },

    infoCard: {
      padding: 28,
    },

    ctaCard: {
      padding: 30,
    },

    ctaTitle: {
      fontSize: 28,
    },

    button: {
      width: "100%",
    },
  },
});

export default function Contact() {
  const classes = useStyles();

  return (
    <section id="contact" className={classes.root}>

      {/* Section heading */}
      <div className={classes.headingContainer}>

        <span className={classes.eyebrow}>
          Get In Touch
        </span>

        <h1 className={classes.heading}>
          Contact Me
        </h1>

      </div>


      {/* Main content */}
      <div className={classes.content}>

        {/* Contact information */}
        <div className={classes.infoCard}>

          <h2 className={classes.title}>
            Let's talk about everything!
          </h2>

          <p className={classes.description}>
            Have a project, idea, or opportunity you'd like to
            discuss? I'd love to hear from you. Feel free to
            reach out and I'll get back to you as soon as possible.
          </p>


          {/* Email */}
          <div className={classes.contactItem}>

            <div className={classes.iconBox}>
              <EmailOutlinedIcon />
            </div>

            <p className={classes.itemText}>
              Email
              <span className={classes.itemValue}>
                <a
                  href="mailto:laraib24@outlook.com"
                  className={classes.emailLink}
                >
                  laraib24@outlook.com
                </a>
              </span>
            </p>

          </div>


          {/* Location */}
          <div className={classes.contactItem}>

            <div className={classes.iconBox}>
              <LocationOnOutlinedIcon />
            </div>

            <p className={classes.itemText}>
              Location
              <span className={classes.itemValue}>
                Available for remote opportunities
              </span>
            </p>

          </div>


          {/* Availability */}
          <div className={classes.contactItem}>

            <div className={classes.iconBox}>
              <AccessTimeOutlinedIcon />
            </div>

            <p className={classes.itemText}>
              Availability
              <span className={classes.itemValue}>
                Open to new opportunities
              </span>
            </p>

          </div>

        </div>


        {/* CTA */}
        <div className={classes.ctaCard}>

          <div className={classes.circleOne} />
          <div className={classes.circleTwo} />

          <div className={classes.ctaContent}>

            <span className={classes.ctaLabel}>
              Have a project in mind?
            </span>

            <h2 className={classes.ctaTitle}>
              Let's build something great together.
            </h2>

            <p className={classes.ctaText}>
              Whether you need a frontend developer, a complete
              full-stack application, or help improving an existing
              product, I'm always open to interesting projects and
              collaborations.
            </p>

            <a
              href="mailto:laraib24@outlook.com"
              className={classes.button}
            >
              Send Me an Email
              <ArrowForwardIcon style={{ fontSize: 18 }} />
            </a>

          </div>

        </div>

      </div>


      <p className={classes.footerText}>
        © {new Date().getFullYear()} Laraib. Available for Remote opportunities.
      </p>

    </section>
  );
}